export default function makeStruct(name, keys, givenOpts) {
  let struct = (...args) => {
    const opts = {
      defaults: {},
      static: {},
      ...givenOpts
    };

    let instance = keys.reduce((acc, key, idx) => {
      if (args[idx] === undefined) acc[key] = opts.defaults[key];
      else acc[key] = args[idx];
      return acc;
    }, opts.static);

    instance._name = name;
    return instance;
  };

  struct.is = s => s && typeof s === "object" && s._name === name;
  return struct;
}
